export enum Country {
  UnitedStates = 'United States',
  Canada = 'Canada',
}
